export default __webpack_public_path__ + "static/media/bently.d6f7fad2.svg";